import { useGetClient } from '../../common/utils/withTokenClient';

export const useEndpointsApi = () => useGetClient('endpoints');
